import { filter } from 'lodash'

export default class ErrorBag {
  constructor () {
    this.message = null
    this.errors = {}
  }

  get (field) {
    if (this.errors[field]) {
      return this.errors[field][0]
    }
  }

  getWithPrefix (prefix) {
    return filter(this.errors, (errors, name) => name.indexOf(prefix) === 0).flat().join(' ') || null
  }

  store (response) {
    if (response.message) {
      this.message = response.message
    }
    if (response.errors) {
      this.errors = response.errors
    }
  }

  delete (field) {
    delete this.errors[field]
  }

  clear () {
    this.message = null
    this.errors = {}
  }
}
